module.exports = __webpack_public_path__ + "img/Focus.bb3b54d2.jpg";